import { render } from "./door-sales-recent-sales-modal.vue?vue&type=template&id=13bb54fe&scoped=true"
import script from "./door-sales-recent-sales-modal.vue?vue&type=script&lang=js"
export * from "./door-sales-recent-sales-modal.vue?vue&type=script&lang=js"

import "./door-sales-recent-sales-modal.vue?vue&type=style&index=0&id=13bb54fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bb54fe"]])

export default __exports__